import React from 'react';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { enumT } from '../../../../utils/helper';

function AntraegeInForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<EditIcon />} title={'Anträge in Förderung'}>
				<MeinBereichButton
					buttonName="Anträge in Förderung ansehen"
					onClick={() => {
						navigate(`/meine-antraege`, {
							state: {
								filter: {
									field: 'Antragsstatus_Antragsstatus',
									operator: 'contains',
									value: enumT('inFoerderung'),
								},
							},
						});
					}}
				/>
				<MeinBereichButton buttonName="Mittelabruf durchführen" disabled={true} />
				<MeinBereichButton buttonName="Verwendungsnachweis einreichen" disabled={true} />
			</MeinBereichPaper>
		</>
	);
}

export default AntraegeInForderung;
